<template>
	<div>
		<j-card class="bg5 p3 flex xs-middle mt4">
			<div class="flex xs-6 xs-left xs-middle fw7 c6">
				Proposal Status
			</div>
			<div class="flex xs-6 xs-right xs-middle">
				<j-tag
					:label="computedProposalStatus ? computedProposalStatus : '---'"
					:variant="computedProposalStatus === 'ISSUED' ? 'success' : 'neutral'"
				/>
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JTag from "@/components/JTag/"

export default {
	components: {
		JCard,
		JTag
	},

	computed: {
		computedProposalStatus() {
			return this.$store.state.caseManagement.proposals?.[0]?.status
		}
	}
}
</script>
